/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthProviderDto
 */
export interface AuthProviderDto {
    /**
     * The unique name.
     * @type {string}
     * @memberof AuthProviderDto
     */
    name: string;
    /**
     * The display name.
     * @type {string}
     * @memberof AuthProviderDto
     */
    displayName: string;
    /**
     * The color.
     * @type {string}
     * @memberof AuthProviderDto
     */
    color: string;
}

/**
 * Check if a given object implements the AuthProviderDto interface.
 */
export function instanceOfAuthProviderDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "color" in value;

    return isInstance;
}

export function AuthProviderDtoFromJSON(json: any): AuthProviderDto {
    return AuthProviderDtoFromJSONTyped(json, false);
}

export function AuthProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthProviderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['displayName'],
        'color': json['color'],
    };
}

export function AuthProviderDtoToJSON(value?: AuthProviderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'displayName': value.displayName,
        'color': value.color,
    };
}

